import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { IoMdAdd } from 'react-icons/io'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Button from '../../../components/General/Button'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'
import Datepicker from '../../../components/Inputs/Datepicker'
import InputNumber from '../../../components/Inputs/InputNumber'
import InputText from '../../../components/Inputs/InputText'
import Select from '../../../components/Inputs/Select'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import { formatPipe, getDenomination } from '../../../utils/utils'

const server = process.env.REACT_APP_SERVER_URL

const AddPaymentForm: React.FC<IAddPaymentForm> = ({ onSubmit, onClose }) => {
  const form = useForm({defaultValues: {amount: 0}})

  const [accounts, setAccounts] = useState<any | null>(null)

  const [selectedAccount, setSelectedAccount] = useState<any | null>(null)

  const { addAlert } = useSnackBars()

  const getAccounts = async (): Promise<void> => {
    let response = await axios.get(`${server}/finances/account`)
    setAccounts(response.data.accounts)
    let { accounts } = response.data
    setSelectedAccount({
      text: accounts[0]?.description,
      value: accounts[0]?.id,
    })
  }

  useEffect(() => {
    getAccounts()
  }, [])

  return (
    <>
      <Form
        form={form}
        classes="gap-x-3"
        onSubmit={(values) => {

          let amount = formatPipe(values?.amount, true)
          if (+amount === 0) {
            addAlert({
              message: 'El pago debe de ser mayor a 0',
              status: 'error',
            })
            return
          } 

          onSubmit(values, accounts, selectedAccount)
        } 
      }
      >
         <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Añadir Pago
      </h2>

        <FormItem name="account" classes="xl:col-span-7 lg:col-span-12">
          <Select
            label="Cuenta"
            value={selectedAccount}
            options={accounts?.map((v) => ({
              text: v?.description,
              value: v?.id,
            }))}
            onChange={(values) => {
              setSelectedAccount(values)
            }}
          />
        </FormItem>

        <FormItem name="date" classes="xl:col-span-5 lg:col-span-12">
          <Datepicker label="Fecha" />
        </FormItem>

        <FormItem name="reference" classes="xl:col-span-7 lg:col-span-12">
          {/* <label className="font-medium text-primary-900 text-xs dark:text-white">
            Referencia
          </label>
          <input
            ref={form.register}
            className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
            type="text"
          /> */}

          <InputText label="Referencia" />
        </FormItem>

        {/* <FormItem
          name="amount"
          classes="xl:col-span-5 lg:col-span-12"
        >
          <InputNumber label="Monto" addDecimals={true} />
        </FormItem> */}

        <FormItem name="amount" classes="xl:col-span-5 lg:col-span-12">
          <CurrencyInput
            label="Monto"
            addDecimals={true}
            mask={`${getDenomination(
              accounts?.find((account) => account?.id === selectedAccount?.value)
                ?.idCurrency
            )} ${accounts?.find((account) => account?.id === selectedAccount?.value)
              ?.idCurrency === '2' ? '.' : ''} num`}
          />
        </FormItem>

        <div className="flex col-span-12 mt-5 justify-center">
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => {
              onClose()
            }}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            classes="w-1/2"
            onClick={() => {}}
          >
            Añadir
          </Button>
        </div>
      </Form>
    </>
  )
}

interface IAddPaymentForm {
  onSubmit: (values: any, accounts: any[], selectedAccount) => void
  onClose: () => void
}

export default AddPaymentForm
